<mat-toolbar class="dashbg">
    <div>
        <a mat-icon-button (click)="clickBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </a>
        <span>{{db.itemsFiltered.length}} Current Deals</span>
    </div>
    <div>
        <profile></profile>
    </div>
</mat-toolbar>
<div class="toolbartop"></div>


<div class="main-container-flex split" [ngClass]="{'s20': !db.isRole('realtor'), 's0': db.isRole('realtor')}"
    *ngIf="db.auth.profile?.values">
    <div class="main">
        <mat-spinner *ngIf="!db.loaded" [strokeWidth]="5"></mat-spinner>
        <!-- <div class="filter-buttons">
        <div class="button-row">
            <mat-button-toggle-group appearance="legacy" (change)="changeTime($event)">
                <mat-button-toggle value=""><mat-icon>all_inclusive</mat-icon></mat-button-toggle>
                <mat-button-toggle value="today" [ngClass]="{active: db.actionTime.today}">Today
                    ({{db.actionTime.today}})</mat-button-toggle>
                 <mat-button-toggle value="future">Future ({{db.actionTime.future}})</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div class="button-row">
            <mat-button-toggle-group appearance="legacy" (change)="changeType($event)">
                <mat-button-toggle value="" matTooltip="All Actions">
                    <mat-icon>all_inclusive</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle [ngClass]="{split : actionType.split}" *ngFor="let actionType of db.actionTypesArray"
                    [value]="actionType.type" [matTooltip]="setting.getParamValueName('actionTypes', actionType.type)">
                    <mat-icon [ngClass]="actionType.color">{{actionType.type | icon:'actionTypes'}}</mat-icon>
                    <span class="badge">{{actionType.nb}}</span>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div> -->
        <!-- <app-table tableKey="main" [item]="actionItem" [items]="db.itemsFilteredOrdered"
        (clickFn)="goItem($event)"></app-table> -->

        <table mat-table [dataSource]="db.itemsFilteredOrdered" class="mat-elevation-z8">

            <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <mat-icon matListIcon [matTooltip]="element.type | param:'actionTypes'">{{element.icon}}</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element"> {{element.date?.toDate() | date:'dd MMM yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>Amount</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.priceDisplay}}
                </td>
            </ng-container>

            <ng-container matColumnDef="projectRealtor">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <img *ngIf="element.project?.realtor" mat-card-avatar [src]="element.project.realtor | realtor"
                        [matTooltip]="element.project.realtor | realtorTooltip" />
                </td>
            </ng-container>

            <ng-container matColumnDef="project">
                <th mat-header-cell *matHeaderCellDef>Project</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.project?.ref">
                        <div>C{{ element.project.ref }}</div>
                        <ng-container *ngIf="element.project.contactsProjects">
                            <div *ngFor="let contactProject of element.project.contactsProjects">
                                {{ contactProject }}
                            </div>
                        </ng-container>
                        <div>{{ element.projectCADisplay }}</div>
                    </ng-container>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="projectCA">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
                {{ element.projectCADisplay }}
            </td>
        </ng-container> -->

            <ng-container matColumnDef="mandateRealtor">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <img *ngIf="element.mandate?.realtor" mat-card-avatar [src]="element.mandate?.realtor | realtor"
                        [matTooltip]="element.mandate.realtor | realtorTooltip" />
                </td>
            </ng-container>

            <ng-container matColumnDef="mandate">
                <th mat-header-cell *matHeaderCellDef>Mandate</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.mandate?.ref">
                        <div>{{ this.setting.prefixMandate + element.mandate.ref }}</div>
                        <ng-container *ngIf="element.mandate.owners">
                            <div *ngFor="let owner of element.mandate.owners">
                                {{ owner }}
                            </div>
                        </ng-container>
                        <div>{{ element.mandateCADisplay }}</div>
                    </ng-container>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="mandateCA">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
                
            </td>
        </ng-container> -->

            <ng-container matColumnDef="totalCA">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.type === 'payment'">
                        {{element.amountDisplay}}
                    </ng-container>
                    <ng-container *ngIf="element.type !== 'payment'">
                        <div>{{element.cy | param:'cies'}} {{ calculTotal(element) | number }}</div>
                        <div *ngIf="element.cy !== 'mur'"
                            [matTooltip]="'Currency Rate: ' + setting.exRates[element.cy]?.mur"
                            [matTooltipDisabled]="element.cy === 'mur'">
                            <i>Rs {{calculTotal(element, true) | number }}</i>
                        </div>
                    </ng-container>

                </td>
            </ng-container>

            <tr mat-header-row
                *matHeaderRowDef="['icon', 'date', 'amount', 'projectRealtor', 'project',  'mandateRealtor', 'mandate','totalCA']; sticky: true">
            </tr>
            <tr mat-row
                *matRowDef="let row; let element; columns: ['icon', 'date', 'amount', 'projectRealtor', 'project', 'mandateRealtor', 'mandate','totalCA'];"
                (click)="goItem(element)">
            </tr>
        </table>
    </div>
    <div class="side" *ngIf="!db.isRole('realtor')">
        <form [formGroup]="sortServerForm" novalidate>

            <mat-form-field formGroupName="arrayFilters" appearance="fill"
                *ngIf="db.auth.profile?.values?.agencies?.length > 1">
                <mat-label>Agency</mat-label>
                <mat-select formControlName="agencies">
                    <mat-option *ngFor="let param of 'userAgencies' | params" [value]="param.id">
                        {{param.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </form>

        <form [formGroup]="sortLocalForm" novalidate>

            <mat-form-field formGroupName="arrayFilters" appearance="fill"
                *ngIf="sortServerForm.controls['arrayFilters'].value?.agencies">
                <mat-label>Realtor</mat-label>
                <mat-select formControlName="realtors">
                    <mat-option value="">
                        All Agents
                    </mat-option>
                    <ng-container>
                        <mat-option
                            *ngFor="let param of setting.realtorsAgency[sortServerForm.controls['arrayFilters'].value?.agencies]"
                            [value]="param.id">
                            {{param.name}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
</div>